var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loader-fade"}},[(_vm.show)?_c('div',{staticClass:"app-loader"},[_c('div',{staticClass:"app-loader-content"},[_c('div',{staticClass:"app-loader-spinner"}),(_vm.message)?_c('div',{staticClass:"app-loader-message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }